import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ContactMessage {
  fromEmail: string;
  subject?: string;
  body?: string;
}

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly http = inject(HttpClient);

  async send(message: ContactMessage): Promise<void> {
    await firstValueFrom(this.http.post<void>(`${environment.apiUrl}/contact-messages`, message));
  }
}
